import './App.css'
import PasswordManager from './PasswordManager'

const App = () => (
  <div>
    <PasswordManager />
  </div>
)

export default App
